import { yupResolver } from '@hookform/resolvers/yup';
import { Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import LoginButton from 'components/Buttons/LoginButton';
import { AppContext } from 'context';
import { acceptTos } from 'services/apiOperations';

const useStyles = makeStyles(theme => ({
  alert: {
    marginBottom: '1.5rem',
  },
  form: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    whiteSpace: 'pre-line',
    width: '100%',
    '& > *': {
      margin: 0,
      marginBottom: '1.5rem',
    },
  },
  logo: {
    height: '3rem',
  },
  error: {
    color: theme.palette.error.main,
  },
}));

interface Props {}

const AcceptTosForm: React.FC<Props> = () => {
  const history = useHistory();
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'acceptTosForm' });
  const schema = yup.object().shape({
    acceptTosCheckbox: yup.bool().oneOf([true], t('validation.mandatoryCheckbox')),
  });

  const handleAccept = async () => {
    await acceptTos(context);
    history.push('/transactions');
  };

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      acceptTosCheckbox: false,
    },
  });

  return (
    <form className={classes.form} onSubmit={handleSubmit(handleAccept)}>
      <img className={classes.logo} alt="citeo" src="logo.svg" />
      <div>
        <Trans i18nKey="acceptTosForm.mustAcceptTos">
          Dans le cadre de votre première connexion à la plateforme vous devez accepter les
          <Link to="/cgu.pdf" target="_blank" download>
            conditions générales d'utilisation
          </Link>
        </Trans>
      </div>
      <Controller
        name="acceptTosCheckbox"
        control={control}
        render={({ field: { ref, ...fieldProps }, fieldState: { error } }) => (
          <>
            <label>
              <Checkbox inputRef={ref} {...fieldProps} />
              {t('IReadAndAcceptedTos')}
            </label>
            {error?.message && <div className={classes.error}>{error.message}</div>}
          </>
        )}
      />
      <LoginButton disabled={isSubmitting}>{t('submit')}</LoginButton>
    </form>
  );
};

export default AcceptTosForm;
